import React from 'react';

const Icon = ({ size = '20', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" {...other}>
            <path d="m7.5 5 5 5-5 5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
export default React.memo(Icon);
